class BlockBuyButton extends HTMLElement {
    constructor() {
        super();
        this.buttonText = this.querySelector(".block-buy-buttons__cart-text");
        this.button = this.querySelector("button");
        this.form = this.querySelector("form");
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));

        this.cart = document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
    }

    connectedCallback() {
        ProductPageStore.subscribe((event, prevState) => {
            const addtoCartText = "장바구니 담기";
            const outOfStockText = "품절";
            const { currentVariant } = event.detail;
            if (currentVariant && currentVariant.available) {
                this.buttonText.textContent = addtoCartText;
                this.button.removeAttribute("disabled");
            } else {
                this.button.setAttribute("disabled", "disabled");
                this.buttonText.textContent = outOfStockText;
            }
        });
    }

    waitUntil(conditionFunction) {
        const poll = (resolve) => {
            if (conditionFunction()) resolve();
            else setTimeout((_) => poll(resolve), 400);
        };

        return new Promise(poll);
    }

    getCrossSellProducts() {
        return [...document.querySelectorAll("block-cross-sell")]
            .map((block) => block.getAddToCartData())
            .filter((block) => block.isAdded)
            .map((block) => ({
                quantity: block.quantity,
                id: block.crossSellVariantId,
            }));
    }

    async onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton.classList.contains("loading")) return;

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove(
            "hidden",
        );

        await this.waitUntil((_) => !!this.cart.loading === false);

        const crossSellItems = this.getCrossSellProducts();
        const sections = this.cart
            .getSectionsToRender()
            .map((section) => section.section);
        const { currentVariant, quantity } = ProductPageStore.getState();
        const { ok, data, error } = await cartService.add(
            [...crossSellItems, { id: currentVariant.id, quantity }],
            sections,
        );
        if (ok) {
            if (data.status) throw new Error(data.description);

            // TODO move this to service render
            this.cart.renderContents(data);

            // TODO move this to service render
            const previousEmpty = $(this.cart).hasClass("is-empty");
            if (previousEmpty) $(this.cart).removeClass("is-empty");
        } else {
            await ResourceCoordinator.requestVendor("Toastr");
            toastr.error(error.message);
        }

        this.submitButton.classList.remove("loading");
        this.submitButton.removeAttribute("aria-disabled");
        this.querySelector(".loading-overlay__spinner").classList.add("hidden");
    }
}

customElements.define("block-buy-button", BlockBuyButton);

class BlockVariantPicker extends HTMLElement {
    constructor() {
        super();
        this.props = {
            options: [],
        };
        this.state = {
            currentProduct: {},
            currentVariant: {},
            currentOptions: [],
        };
        this.sectionId = this.getAttribute("section-id");
    }

    initProps() {
        this.props.options = JSON.parse(this.getAttribute("options"));
    }

    initState() {
        const { currentProduct, currentVariant } = ProductPageStore.getState();
        this.state.currentVariant = currentVariant;
        this.state.currentProduct = currentProduct;
        this.state.currentOptions = this.createOptionsData(
            this.props.options,
            currentVariant,
        );
    }

    connectedCallback() {
        this.initProps();
        this.initState();
        this.render();
        this.setupEventListeners();

        ProductPageStore.subscribe((event, prevState) => {
            const { currentProduct, currentVariant } = event.detail;

            if (currentProduct?.handle === prevState?.currentProduct?.handle)
                return;

            this.setState({ currentProduct, currentVariant });
        });
    }

    createOptionsData(rawOptions, currentVariant) {
        return rawOptions.map((option) => ({
            ...option,
            currentValue: currentVariant[`option${option.position}`],
        }));
    }

    setupEventListeners() {
        const chipGroups = this.querySelectorAll("[data-option-index]");
        chipGroups.forEach((group) => {
            group.addEventListener("click", (event) => {
                const button = event.target.closest("button[data-value]");
                if (!button) return;

                const optionIndex = parseInt(
                    group.getAttribute("data-option-index"),
                    10,
                );
                const value = button.getAttribute("data-value");
                this.onChipSelect(optionIndex, value);
            });
        });
    }

    setState(newState) {
        const scrollMap = new Map();
        this.querySelectorAll("[data-option-index]").forEach((group) => {
            const index = group.getAttribute("data-option-index");
            scrollMap.set(index, group.scrollLeft);
        });

        this.state = { ...this.state, ...newState };
        this.render();

        this.querySelectorAll("[data-option-index]").forEach((group) => {
            const index = group.getAttribute("data-option-index");
            if (scrollMap.has(index)) {
                group.scrollLeft = scrollMap.get(index);
            }
        });
    }

    render() {
        this.innerHTML = `
      ${this.state.currentOptions
          .map(
              (option, optionIndex) => `
            <div class="mb-4">
              <div class="text-sm font-semibold mb-2">${option.name}</div>
              <div class="flex gap-2 overflow-x-auto sm:overflow-visible sm:flex-wrap flex-nowrap no-scrollbar"
                  data-option-index="${optionIndex}">
                ${option.values
                    .map((value) => {
                        const isSelected = value === option.currentValue;
                        return `
                    <button
                      type="button"
                      class="${[
                          "shrink-0 px-4 py-2 rounded-lg text-sm border",
                          isSelected
                              ? "border-orange-500 bg-orange-50 font-semibold"
                              : "border-gray-300 bg-white",
                      ].join(" ")}"
                      data-value="${value}"
                    >
                      ${value}
                    </button>
                  `;
                    })
                    .join("")}
              </div>
            </div>
          `,
          )
          .join("")}
    `;
        this.setupEventListeners();
    }

    onChipSelect(optionIndex, value) {
        const updatedOptions = [...this.state.currentOptions];
        updatedOptions[optionIndex].currentValue = value;

        const currentVariant = this.state.currentProduct.variants.find(
            (variant) => {
                return updatedOptions.every(
                    (option, index) =>
                        variant[`option${index + 1}`] === option.currentValue,
                );
            },
        );

        this.setState({ currentOptions: updatedOptions });
        ProductPageStore.setState({ currentVariant });
        window.dispatchEvent(new Event("productVariantChange"));
    }
}

customElements.define("block-variant-picker", BlockVariantPicker);

class BlockVariantSelection extends HTMLElement {
    constructor() {
        super();
        this.props = {
            options: [],
        };
        this.state = {
            currentProduct: {},
            currentVariant: {},
            currentOptions: [],
        };
        this.sectionId = this.getAttribute("section-id");
    }

    initProps() {
        this.props.options = JSON.parse(this.getAttribute("options"));
    }

    initState() {
        const { currentProduct, currentVariant } = ProductPageStore.getState();
        this.state.currentVariant = currentVariant;
        this.state.currentProduct = currentProduct;
        this.state.currentOptions = this.createOptionsData(
            this.props.options,
            currentVariant,
        );
    }

    connectedCallback() {
        this.initProps();
        this.initState();
        this.render();
        this.setupEventListeners();

        ProductPageStore.subscribe((event, prevState) => {
            const { currentProduct, currentVariant } = event.detail;

            if (currentProduct?.handle !== prevState?.currentProduct?.handle) {
                this.setState({ currentProduct, currentVariant });
                return;
            }

            if (currentVariant?.id !== prevState?.currentVariant?.id) {
                window.eventBus.publish(
                    "main-product:variant-change",
                    currentVariant,
                );
            }
        });

        this.querySelectorAll("select[data-option-index]").forEach((select) => {
            select.addEventListener("change", (event) => {
                const optionIndex = parseInt(
                    select.getAttribute("data-option-index"),
                    10,
                );
                const value = event.target.value;
                this.onChipSelect(optionIndex, value);
            });
        });
    }

    createOptionsData(rawOptions, currentVariant) {
        return rawOptions.map((option) => ({
            ...option,
            currentValue: currentVariant[`option${option.position}`],
        }));
    }

    setupEventListeners() {
        const chipGroups = this.querySelectorAll("[data-option-index]");
        chipGroups.forEach((group) => {
            group.addEventListener("change", (event) => {
                const optionIndex = parseInt(
                    group.getAttribute("data-option-index"),
                    10,
                );
                const value = event.target.value;
                this.onChipSelect(optionIndex, value);
            });
        });
    }

    setState(newState) {
        const scrollMap = new Map();
        this.querySelectorAll("[data-option-index]").forEach((group) => {
            const index = group.getAttribute("data-option-index");
            scrollMap.set(index, group.scrollLeft);
        });

        this.state = { ...this.state, ...newState };
        this.render();

        this.querySelectorAll("[data-option-index]").forEach((group) => {
            const index = group.getAttribute("data-option-index");
            if (scrollMap.has(index)) {
                group.scrollLeft = scrollMap.get(index);
            }
        });
    }

    render() {
        this.innerHTML = `
${this.state.currentOptions
    .map((option, optionIndex) => {
        const isSize = option.name.toLowerCase() === "size";

        if (isSize) {
            return `
              <div class="mb-2 relative text-[#403833]">
                <span class="absolute h-4 font-semibold px-1 left-[9px] -top-[10px] bg-white text-sm">사이즈 선택</span>

                <select
                  data-option-index="${optionIndex}"
                  class="w-full border p-3 rounded-lg text-base border-[#7B7571] appearance-none bg-none"
                >
                  ${option.values
                      .map(
                          (value) => `
                      <option value="${value}" ${
                          value === option.currentValue ? "selected" : ""
                      }>
                        ${value}
                      </option>
                    `,
                      )
                      .join("")}
                </select>

                <svg class="absolute top-1/2 -translate-y-1/2 right-3" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17.9419 6.22412C17.6978 5.97998 17.3022 5.97998 17.0581 6.22412L10 13.2822L2.9419 6.22412C2.69776 5.97998 2.30225 5.97998 2.05811 6.22412C1.81396 6.46826 1.81396 6.86377 2.05811 7.10791L9.55811 14.6079C9.68018 14.73 9.8401 14.791 10 14.791C10.1603 14.791 10.3198 14.73 10.4419 14.6079L17.9419 7.10791C18.186 6.86376 18.186 6.46826 17.9419 6.22412Z" fill="currentColor"/>
                </svg>
              </div>
            `;
        }

        return `
      <div class="mb-4">
        <div class="text-sm font-semibold mb-2">${option.name}</div>
        <div class="flex gap-2 overflow-x-auto sm:overflow-visible sm:flex-wrap flex-nowrap no-scrollbar"
            data-option-index="${optionIndex}">
          ${option.values
              .map((value) => {
                  const isSelected = value === option.currentValue;
                  return `
              <button
                type="button"
                class="${[
                    "shrink-0 px-4 py-2 rounded-lg text-sm border",
                    isSelected
                        ? "border-orange-500 bg-orange-50 font-semibold"
                        : "border-gray-300 bg-white",
                ].join(" ")}"
                data-value="${value}"
              >
                ${value}
              </button>
            `;
              })
              .join("")}
        </div>
      </div>
    `;
    })
    .join("")}
    `;
        this.setupEventListeners();
    }

    onChipSelect(optionIndex, value) {
        const updatedOptions = [...this.state.currentOptions];
        updatedOptions[optionIndex].currentValue = value;

        const currentVariant = this.state.currentProduct.variants.find(
            (variant) => {
                return updatedOptions.every(
                    (option, index) =>
                        variant[`option${index + 1}`] === option.currentValue,
                );
            },
        );

        this.setState({ currentOptions: updatedOptions });
        ProductPageStore.setState({ currentVariant });
        window.dispatchEvent(new Event("productVariantChange"));
    }
}

customElements.define("block-variant-selection", BlockVariantSelection);

class BlockPrice extends HTMLElement {
    constructor() {
        super();
        this.props = { variant: {} };
        this.state = {
            quantity: 1,
            currentMainProductVariant: {},
            crossSellVariants: [],
            status: "idle", // idle | hidden
        };
    }

    connectedCallback() {
        this.layout = this.getAttribute("layout") || "normal";
        this.vatText = this.getAttribute("vat-text") || "VAT 포함";
        this.initState();
        this.render(this.getRenderData());
        this.monitorCrossSellChanges();

        ProductPageStore.subscribe((event) => {
            const { currentVariant, quantity } = event.detail;
            // TODO improve
            if (!currentVariant) {
                this.style.display = "none";
            } else {
                this.style.display = "block";
                this.updateState({
                    status: "idle",
                    currentMainProductVariant: currentVariant,
                    quantity,
                });
            }
        });
    }

    initState() {
        this.state = {
            ...this.state,
            quantity: ProductPageStore.getState().quantity,
            currentMainProductVariant:
                ProductPageStore.getState().currentVariant,
        };
    }

    monitorCrossSellChanges() {
        const section = this.closest("section");
        if (!section) return;

        section.querySelectorAll("block-cross-sell").forEach((item) => {
            item.addEventListener("update", (event) => {
                const data = this.getCrossSellData(event.detail);
                const product = this.state.crossSellVariants.find(
                    (item) => item.id === data.id,
                );
                const updates = product
                    ? this.state.crossSellVariants.map((item) =>
                          item.id === data.id ? data : item,
                      )
                    : [...this.state.crossSellVariants, data];
                this.updateState({ crossSellVariants: updates });
            });
        });
    }

    getCrossSellData(data) {
        const result = {};
        result.id = data.crossSellProductId;
        result.isAdded = data.status === "active";
        result.variant = data.currentCrossSellProductVariant;
        result.isDiscounted = data.price < data.compareAtPrice;
        result.quantity = data.quantity;
        return result;
    }

    updateState(updates) {
        this.state = { ...this.state, ...updates };
        this.render(this.getRenderData());
        this.notifyStateChange();
    }

    notifyStateChange() {
        const event = new CustomEvent("update", { detail: { ...this.state } });
        this.dispatchEvent(event);
    }

    getRenderData() {
        const variant = this.state.currentMainProductVariant;
        const result = {};
        result.isDiscounted = variant.compare_at_price > variant.price;
        result.price = this.calculateRegularPrice(
            variant.price,
            this.state.quantity,
        );
        result.compareAtPrice = this.calculateCompareAtPrice(
            variant.compare_at_price,
            this.state.quantity,
        );
        result.discountPercentage = Math.round(
            ((variant.compare_at_price - variant.price) * 100) /
                variant.compare_at_price,
        );
        return result;
    }

    calculateRegularPrice(price, quantity) {
        const totalProductPrice = (price / 100) * quantity;
        const totalCrossSellPrice = this.state.crossSellVariants
            .filter((item) => item.isAdded)
            .reduce(
                (total, item) =>
                    total + (item.variant.price / 100) * item.quantity,
                0,
            );
        return totalProductPrice + totalCrossSellPrice;
    }

    calculateCompareAtPrice(price, quantity) {
        const totalProductPrice = (price / 100) * quantity;
        const totalCrossSellPrice = this.state.crossSellVariants
            .filter((item) => item.isAdded)
            .reduce(
                (total, item) =>
                    total +
                    (item.variant.compare_at_price / 100) * item.quantity,
                0,
            );
        return totalProductPrice + totalCrossSellPrice;
    }

    hidePrice() {
        this.updateState({ status: "hidden" });
    }

    render(data) {
        if (this.state.status === "hidden") {
            this.innerHTML = "";
            return;
        }

        if (this.layout === "top") {
            this.innerHTML = `
        ${
            data.isDiscounted
                ? `<span class="text-xs font-semibold text-negative-500">${data.discountPercentage}% 할인</span>`
                : ""
        }
        <div>
          <div class="price__sale flex justify-start flex-row gap-1">
            ${
                data.isDiscounted
                    ? `<span class="text-sm text-neutral-900 line-through">${data.compareAtPrice.toLocaleString()}원</span>`
                    : ""
            }
            <span class="text-sm font-semibold text-negative-500">${data.price.toLocaleString()}원</span>
            
          </div>
          <span class="text-xs text-[var(--color-neutral-700)]">(${this.vatText})</span>
        </div>
      `;
            return;
        }

        this.innerHTML = `
      ${
          data.isDiscounted
              ? `<div class="flex mb-1 justify-center items-center text-xs text-white font-bold max-w-max bg-[#DA1F00] rounded p-1">${data.discountPercentage}% 할인</div>`
              : ""
      }
      <div>
        <div class="price__sale flex justify-start flex-col">
          ${
              data.isDiscounted
                  ? `<span class="price-item price-item--sale ">         
            <s class="text-sm font-semibold text-[#2E2F3C]">${data.compareAtPrice.toLocaleString()}원</s>
          </span>`
                  : ""
          }
          <div class="grid grid-cols-[max-content_max-content] gap-2 py-2">
            <span class="text-[#DA1F00] font-semibold text-[32px] price-item--regular leading-none">${data.price.toLocaleString()}<span class="text-2xl">원</span></span>
          </div>
        </div>
      </div>
    `;
    }
}

customElements.define("block-price", BlockPrice);

class BlockQuantitySelector extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector("input");
        this.changeEvent = new Event("change", { bubbles: true });

        this.querySelectorAll("button").forEach((button) =>
            button.addEventListener("click", this.onButtonClick.bind(this)),
        );
    }

    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;

        event.currentTarget.name === "plus"
            ? this.input.stepUp()
            : this.input.stepDown();
        if (previousValue !== this.input.value) {
            this.input.dispatchEvent(this.changeEvent);
            this.updateQuantityInput();
            this.updateUI();
        }
    }

    updateUI() {
        this.querySelectorAll("button").forEach((button) => {
            button.disabled = button.name === "minus" && this.input.value <= 1;
        });
    }

    updateQuantityInput() {
        ProductPageStore.setState({ quantity: Number(this.input.value) });
    }
}

customElements.define("block-quantity-selector", BlockQuantitySelector);

class BlockPaymentMethods extends HTMLElement {
    constructor() {
        super();
        this.BNPLAmount = this.querySelector("#BNPL-amount");
        this.tooltip = null;
    }

    connectedCallback() {
        this.initEventListener();
    }

    initProps() {
        this.props = JSON.parse(this.getAttribute(":props"));
    }

    initEventListener() {
        this.querySelector('button[name="popup"]')?.addEventListener(
            "click",
            this.showPopup.bind(this),
        );
        this.closest("section")
            .querySelector("block-price")
            .addEventListener("update", this.renderMoney.bind(this));
    }

    showPopup() {}

    renderMoney(event) {
        const blockPriceState = event.detail;
        const price = this.calculateRegularPrice(blockPriceState);
        const BNPLPrice = this.calculateBNPLAmount(price);
        this.BNPLAmount.innerHTML = currencyFormatter.format(BNPLPrice);
    }

    calculateBNPLAmount(price) {
        return Number(price / 12).toFixed(0);
    }

    calculateRegularPrice(data) {
        const totalProductPrice =
            (data.currentMainProductVariant.price / 100) * data.quantity;
        const totalCrossSellPrice = data.crossSellVariants
            .filter((item) => item.isAdded)
            .reduce(
                (total, item) =>
                    total + (item.variant.price / 100) * item.quantity,
                0,
            );
        return totalProductPrice + totalCrossSellPrice;
    }
}

customElements.define("block-payment-methods", BlockPaymentMethods);

class BlockProductSelector extends HTMLElement {
    constructor() {
        super();
        this.props = { product: {}, description: "" };
        this.state = { currentVariant: {} };
    }

    connectedCallback() {
        this.initProps();
        this.initState();
        this.render(this.getRenderData());
        this.initEventListeners();

        ProductPageStore.subscribe((event) => {
            const currentVariant = this.getMatchedVariantSize();
            this.updateState({
                currentVariant: currentVariant
                    ? currentVariant
                    : this.props.product.variants[0],
            });
        });

        window.eventBus.publish("block-product-selector:rendered", {
            component: this,
            price: this.state.currentVariant.price,
            handle: this.props.product.handle,
        });
    }

    initProps() {
        this.props.product = JSON.parse(this.getAttribute(":product"));
        this.props.description = this.getAttribute(":description");
        this.props.freebies = JSON.parse(this.getAttribute(":freebies")) ?? [];
        this.props.urgencyCheckoutHtml = JSON.parse(
            this.getAttribute(":urgencycheckouthtml"),
        );
    }

    initState() {
        const currentVariant = this.getMatchedVariantSize();
        this.updateState({
            currentVariant: currentVariant
                ? currentVariant
                : this.props.product.variants[0],
        });
    }

    initEventListeners() {
        this.addEventListener("click", this.handleClick.bind(this));
    }

    updateState(updates) {
        this.state = { ...this.state, ...updates };
        this.render(this.getRenderData());
    }

    getMatchedVariantSize() {
        const currentVariant = ProductPageStore.getState().currentVariant;
        if (!currentVariant) return null;

        const size = currentVariant.title.split("(")[0].trim();
        const regex = new RegExp(String.raw`^${size}$`, "i");
        return this.props.product.variants.find((variant) =>
            regex.test(variant.title.split("(")[0].trim()),
        );
    }

    handleClick() {
        ProductPageStore.setState({
            currentProduct: this.props.product,
            currentVariant: this.state.currentVariant,
            urgencyCheckoutHtml: this.props.urgencyCheckoutHtml,
            freebies: this.props.freebies,
        });
    }

    getRenderData() {
        const result = {};
        result.title = this.props.product.title;
        result.price = this.state.currentVariant.price / 100;
        result.compareAtPrice =
            this.state.currentVariant.compare_at_price / 100;
        result.isDiscounted =
            this.state.currentVariant.compare_at_price >
            this.state.currentVariant.price;
        result.discountPercentage = Math.round(
            ((this.state.currentVariant.compare_at_price -
                this.state.currentVariant.price) *
                100) /
                this.state.currentVariant.compare_at_price,
        );
        result.description = this.props.description;
        result.isSelected =
            ProductPageStore.getState().currentProduct.id ===
            this.props.product.id;
        return result;
    }

    render(data) {
        this.innerHTML = `
      <div class="p-5 rounded-lg ${
          data.isSelected
              ? "border-[#FF8900] border-2"
              : "border-[#9C9794] border hover:bg-[#efeff3] hover:border-[#e5e7eb] transition-colors"
      }">
        <p class="font-semibold text-[16px] mb-2">${data.title}</p>
        <div class="flex items-center gap-2 mb-5">
          ${
              data.isDiscounted
                  ? `<p class="md:flex hidden justify-center items-center text-xs text-white font-bold max-w-max bg-[#DA1F00] rounded p-1">${data.discountPercentage}% 할인</p>`
                  : ""
          }
          ${data.isDiscounted ? `<p class="text-sm line-through">${data.compareAtPrice.toLocaleString()}원</p>` : ""}
          <p class="text-sm ${data.isDiscounted ? "text-[#DA1F00] font-semibold" : ""}">
          ${data.price.toLocaleString()}원
          </p>
        </div>
        <p class="text-[16px] text-[#7B7571]">${data.description}</p>
      </div>
    `;
    }
}

customElements.define("block-product-selector", BlockProductSelector);

ProductPageStore.subscribe((event, prevState) => {
    const { currentProduct, currentVariant } = event.detail;

    if (currentProduct?.handle === prevState?.currentProduct?.handle) return;

    fetchProductPage(currentProduct.handle).then((html) => {
        const parser = new DOMParser();
        const productDocument = parser.parseFromString(html, "text/html");

        replaceElements(productDocument, [
            ".product__title h1",
            "judgeme-star-override",
            "product-description",
            "#block-bundle-information",
            "block-product-media-gallery",
            "block-variant-picker",
        ]);

        if (window.lozad) window.lozad(".lazyload").observe();
    });

    function replaceElements(sourceDocument, selectors) {
        selectors.forEach((selector) => {
            const targetElements = document.querySelectorAll(selector);
            const sourceElements = sourceDocument.querySelectorAll(selector);

            if (targetElements.length !== sourceElements.length) {
                console.warn(
                    `Mismatch in number of elements for selector "${selector}". ` +
                        `Target: ${targetElements.length}, Source: ${sourceElements.length}`,
                );
            }

            targetElements.forEach((targetElement, index) => {
                if (index < sourceElements.length) {
                    targetElement.replaceWith(
                        sourceElements[index].cloneNode(true),
                    );
                } else {
                    console.warn(
                        `No matching source element for target at index ${index} with selector "${selector}"`,
                    );
                }
            });
        });
    }
});

class BlockJointProductBanner extends HTMLElement {
    constructor() {
        super();

        this.props = { product: {}, mainProductId: 0 };
        this.sectionIds = [
            "section-alternate-banners",
            "mattress-layers",
            "background-image-banner",
        ];
    }

    async connectedCallback() {
        this.initProps();
        this.render(await this.getRenderData());
    }

    initProps() {
        this.props.product = JSON.parse(this.getAttribute(":product"));
        this.props.mainProductId = Number(this.getAttribute(":mainProductId"));
    }

    getRenderData() {
        return this.props.mainProductId === this.props.product.id
            ? this.fetchInternal()
            : this.fetchExternal();
    }

    fetchInternal() {
        let templates = [];

        this.sectionIds.forEach((sectionId) => {
            const section = document.querySelector(
                `.shopify-section[id$="${sectionId}"]`,
            );
            if (section) {
                const sectionContent =
                    section.querySelector(".section-content");
                templates.push(sectionContent.outerHTML);
                section.remove();
            }
        });

        const widget = document.querySelector(
            `.jdgm-widget.jdgm-review-widget[data-id="${this.props.mainProductId}"]`,
        );
        if (widget) {
            templates.push(widget.outerHTML);
            widget.parentElement.remove();
        }

        return templates.join("");
    }

    async fetchExternal() {
        const html = await fetchProductPage(this.props.product.handle);
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        let templates = [];

        this.sectionIds.forEach((sectionId) => {
            const section = doc.querySelector(
                `.shopify-section[id$="${sectionId}"]`,
            );
            if (section) {
                const sectionContent =
                    section.querySelector(".section-content");
                templates.push(sectionContent.outerHTML);
            }
        });

        return templates.join("");
    }

    render(template) {
        this.insertAdjacentHTML("afterbegin", template);
        if (window.lozad) window.lozad(".lazyload").observe();
    }
}

customElements.define("block-joint-product-banner", BlockJointProductBanner);

class MattressLayersSplide extends HTMLElement {
    constructor() {
        super();
        this.addStyle();
    }

    async connectedCallback() {
        await wait(1000);

        await ResourceCoordinator.requestVendor("Splide");

        const splide = new Splide(this.querySelector(".splide"), {
            arrow: false,
            destroy: false,
            mediaQuery: "min",
        });

        splide.on("pagination:mounted", function (data) {
            data.items.forEach(function (item) {
                item.button.textContent = String(item.page + 1);
            });
        });

        splide.mount();
    }

    addStyle() {
        const style = document.createElement("style");
        style.textContent = String.raw`
      mattress-layers-splide .splide__arrows {
        display: none;
      }

      mattress-layers-splide .splide__pagination {
        position: static;
        display: flex;
        padding: 16px 0;
      }

      mattress-layers-splide .splide__pagination .splide__pagination__page {
        width: 30px;
        height: 30px;
        margin: 0;

        background-color: transparent !important;
        border: 1px solid #9A9CB2;
        border-radius: 50%;

        display: flex;
        justify-content: center;
        align-items: center;
        transform: none;

        color: #9a9cb2;
        font-weight: 600;
      }

      mattress-layers-splide .splide__pagination .splide__pagination__page.is-active {
        border: 2px solid #FF8900;
        background-color: #FFF6EC;
        color: #2E2F3C;
      }

      mattress-layers-splide .splide__track {
        padding-bottom: 0;
      }
    `;
        this.appendChild(style);
    }
}

customElements.define("mattress-layers-splide", MattressLayersSplide);

document.addEventListener("DOMContentLoaded", async function () {
    const section = document.querySelector("#joint-product-banners");
    if (section) {
        const tabs = initTabs(section);
        tabs.init();
    }
});

class BlockUsp extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.learnMoreBtn = this.querySelector("[data-block-usp--learn-more]");
        this.contentDiv = this.querySelector("[data-block-usp--content]");
        this.drawerId = "usp-drawer";

        this.learnMoreBtn?.addEventListener("click", () => this.openDrawer());
    }

    openDrawer() {
        const content = this.contentDiv?.innerHTML || "";

        let drawer = document.getElementById(this.drawerId);
        if (!drawer) {
            drawer = document.createElement("div");
            drawer.id = this.drawerId;
            drawer.className = `
        fixed bottom-0 left-0 right-0 bg-white border-t border-gray-300
        max-h-[70vh] overflow-y-auto p-6 z-50 transition-transform transform translate-y-full
      `;
            drawer.innerHTML = `
        <div class="flex justify-between items-start mb-4">
          <h2 class="text-lg font-semibold font-inter">More Information</h2>
          <button id="usp-drawer-close" class="text-sm underline">Close</button>
        </div>
        <div id="usp-drawer-content" class="text-sm text-gray-700 shopify-richtext"></div>
      `;
            document.body.appendChild(drawer);

            drawer
                .querySelector("#usp-drawer-close")
                ?.addEventListener("click", () => {
                    drawer.classList.add("translate-y-full");
                });
        }

        drawer.querySelector("#usp-drawer-content").innerHTML = content;

        requestAnimationFrame(() => {
            drawer.classList.remove("translate-y-full");
        });
    }
}

customElements.define("block-usp", BlockUsp);
